export default "skymp5-front/0570729a8226165bdc950bd1e4ae43e0.gif";